import { render, staticRenderFns } from "./free-respins.vue?vue&type=template&id=6b44d53f&scoped=true&"
import script from "./free-respins.vue?vue&type=script&lang=js&"
export * from "./free-respins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b44d53f",
  null
  
)

export default component.exports